import { getCurrentInstance, onMounted } from 'vue'

let labelCounter = 0

function hasAccessibleName(el: HTMLElement): boolean {
  if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return true
  if (el.id && el.ownerDocument.querySelector(`label[for="${CSS.escape(el.id)}"]`)) return true
  return el.closest('label') !== null
}

function findNearbyLabel(el: HTMLElement): HTMLLabelElement | null {
  const direct = el.previousElementSibling
  if (direct instanceof HTMLLabelElement) return direct

  // Поле обёрнуто (иконка, кнопка очистки): метка стоит перед обёрткой
  const parent = el.parentElement
  const wrapperSibling = parent?.previousElementSibling
  if (wrapperSibling instanceof HTMLLabelElement) return wrapperSibling

  // <div><label>Статус</label><UiSelect/></div> с лишними соседями между ними
  const siblingLabels = parent ? [...parent.children].filter((c) => c instanceof HTMLLabelElement) : []
  return siblingLabels.length === 1 ? (siblingLabels[0] as HTMLLabelElement) : null
}

/**
 * В проекте метки рисуются соседним <label> без `for`, поэтому у поля нет доступного имени.
 * Привязываем ближайшую метку через aria-labelledby, а при её отсутствии берём placeholder.
 */
export function associateLabel(el: HTMLElement): void {
  if (hasAccessibleName(el)) return

  const label = findNearbyLabel(el)
  if (label?.textContent?.trim()) {
    if (!label.id) label.id = `auto-label-${++labelCounter}`
    el.setAttribute('aria-labelledby', label.id)
    return
  }

  const placeholder = el.getAttribute('placeholder')
  if (placeholder?.trim()) el.setAttribute('aria-label', placeholder.trim())
}

/** Вызывать в setup() UI-компонента с одним корневым полем ввода. */
export function useAutoLabel(): void {
  const instance = getCurrentInstance()
  onMounted(() => {
    const root = instance?.proxy?.$el
    if (root instanceof HTMLElement) associateLabel(root)
  })
}
